<template>
  <div class="renew-tile" @click="$emit('click')">
    <div class="tile-header">
      <div class="plan-name">
        <span>{{ service.name }}</span>
        <v-icon class="flag-icon" small>{{ iconFlag(service.flag) }}</v-icon>
      </div>
    </div>
    <div class="tile-body">
      <div class="domain-name">{{ service.domain }}</div>
      <div class="renewal-info">
        <div class="info-row">
          <span class="info-label">Billing Cycle</span>
          <span class="info-value">{{ capitalizeFirst(service.renewalterm) }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Next Renewal</span>
          <span class="info-value">{{ formatRenewalDate(parseRenewalDate(service.renewaldate)) }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Renewal Cost</span>
          <span class="info-value">${{ parseFloat(service.renewalcost).toFixed(2) }}</span>
        </div>
      </div>
    </div>
    <div class="tile-footer">
      <button class="renew-btn">
        <v-icon small class="mr-1">mdi-refresh</v-icon>
        Renewal Options
      </button>
    </div>
  </div>
</template>

<script>
import { iconFlag, parseRenewalDate, formatRenewalDate } from '@/helpers/helpers'

export default {
  name: 'RenewServiceTile',

  props: {
    service: {
      type: Object,
      required: true,
    },
  },

  methods: {
    iconFlag,
    parseRenewalDate,
    formatRenewalDate,
    capitalizeFirst (str) {
      if (!str) return ''
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    },
  },
}
</script>

<style scoped lang="scss">
.renew-tile {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;

  &:hover {
    border-color: #2e7d32;
    box-shadow: 0 4px 16px rgba(46, 125, 50, 0.15);

    .renew-btn {
      background: #1b5e20;
    }
  }
}

.tile-header {
  padding: 16px 16px 12px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
}

.plan-name {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 15px;
  color: #333;

  .flag-icon {
    margin-left: 8px;
  }
}

.tile-body {
  flex: 1;
  padding: 16px;
}

.domain-name {
  font-size: 14px;
  font-weight: 500;
  color: #2e7d32;
  margin-bottom: 16px;
  word-break: break-word;
}

.renewal-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.info-label {
  color: #666;
}

.info-value {
  color: #333;
  font-weight: 500;
}

.tile-footer {
  padding: 12px 16px 16px;
}

.renew-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 16px;
  background: #2e7d32;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #1b5e20;
  }
}
</style>

<!-- Dark mode styles (unscoped to access parent .theme--dark) -->
<style lang="scss">
.theme--dark {
  .renew-tile {
    background: #002838;
    border-color: rgba(101, 101, 101, 0.4);

    &:hover {
      border-color: #2e7d32;
      box-shadow: 0 4px 16px rgba(46, 125, 50, 0.25);
    }
  }

  .tile-header {
    background: #08445d;
    border-bottom-color: rgba(101, 101, 101, 0.4);
  }

  .plan-name {
    color: #fff;
  }

  .info-label {
    color: #9e9e9e;
  }

  .info-value {
    color: #fff;
  }
}
</style>
